<template>
  <div class="search container">
    <template v-if="isSignedIn">
    <h4 class="subtitle">Search for folders on Drive</h4>
    <!-- <form id="search" class="form-inline md-form form-sm" v-on:submit.prevent="onSearch"> -->
    <form @submit.prevent.stop="onSearch" class="form-inline md-form form-sm row">
      <input class="form-control mr-3 w-75" type="search" placeholder="Search" v-model="search.text" :readonly="state==='loading'" @keydown.enter="$event.stopPropagation()"/>
      <button class="btn btn-outline-primary" @click.stop.prevent="onSearch" :disabled="state==='loading'">Search</button>
    </form>
    <div class="query-reference small">
      <a href="https://developers.google.com/drive/api/v3/reference/query-ref" target="_blank">https://developers.google.com/drive/api/v3/reference/query-ref</a>
    </div>
    <!-- </form> -->
    <div v-if="state==='success' && apiResult && apiResult.files.length">
      <g-files-result-item v-for="(gFile, index) in apiResult.files" :gFile="gFile" :key="index" class="gFolder">
      </g-files-result-item>
    </div>
    <div v-if="state==='loading'">loading..</div>
    <div v-if="state==='error'"><pre>{{apiResult}}</pre></div>
    <!-- <pre>{{apiResult}}</pre> -->
    </template>
  </div>
</template>

<script>
// @ is an alias to /src
// import { mapState } from 'vuex'
// import GFilesList from '@/components/GFilesList.vue'
import GFilesResultItem from '@/components/search/GFileResultItem.vue'
import { GApiMixin } from '@/mixins/GApiMixin.js'

export default {
  name: 'Search',
  mixins: [GApiMixin],
  components: {
    GFilesResultItem
  },
  data () {
    return {
      apiResult: '',
      state: 'none',
      search: {
        text: '',
        result: null
      }
    }
  },
  computed: {
    gRootFolderId: {
      get () {
        return this.$store.state.gRootFolderId
      },
      set (val) {
        this.$store.commit('setGRootFolderId', val)
      }
    }
  },
  created () {
  },
  methods: {
    onSearch () {
      // Field | Value Type | Operators | Description
      // name | string | contains, =, != | Name of the file.
      // fullText | string | contains | Full text of the file including name, description, content, and indexable text.
      // mimeType | string | contains, =, != | MIME type of the file.
      // modifiedTime | date | <=, <, =, !=, >, >= | Date of the last modification of the file.
      // viewedByMeTime | date | <=, <, =, !=, >, >= | Date that the user last viewed a file.
      // trashed | boolean | =, != | Whether the file is in the trash or not.
      // starred | boolean | =, != | Whether the file is starred or not.
      // parents | collection | in | Whether the parents collection contains the specified ID.
      // owners | collection | in | Users who own the file.
      // writers | collection | in | Users who have permission to modify the file.
      // readers | collection | in | Users who have permission to read the file.
      // sharedWithMe | boolean | =, != | Files that have been shared with the authorized user.
      // properties | collection | has | Public custom file properties.
      // appProperties | collection | has | Private custom file properties.
      const tests = [
        // 'name = \'',
        // 'name contains \'',
        // 'not name contains \'',
        // 'fullText contains \'',
        // 'not fullText contains \'',
        ' contains \'',
        '\' in parents',
        '\' in writers',
        '\' in readers',
        ' <= ', ' < ', ' = ', ' != ', ' > ', ' >= '
        // 'visibility = \'',
        // ' != \''
      ]
      let found = -1
      let q = this.search.text
      for (let i = 0; i < tests.length; i++) {
        found = this.search.text.search(tests[i])
        if (found > -1) {
          break
        }
      }
      if (found < 0) {
        q = 'name contains \'' + this.search.text + '\''
      }
      // if (!q) console.log('error, q:', q)
      this.listFolders(q)
    },
    listFolders (searchterm) {
      let q = searchterm
      q += ' and mimeType = \'application/vnd.google-apps.folder\' and trashed = false'
      // console.log('q:', q)
      this.state = 'loading'
      window.gapi.client.drive.files.list({
        // pageSize: 10,
        q: q,
        supportsAllDrives: true,
        includeItemsFromAllDrives: true,
        // fields: 'nextPageToken, files(*)',
        fields: 'nextPageToken, files(id,name,description,kind,mimeType,createdTime,parents,webViewLink,iconLink,owners,driveId)',
        orderBy: 'createdTime desc, name'
      }).then(response => {
        // console.log('listFiles', response)
        this.state = 'success'
        this.apiResult = response.result
        for (let i = 0; i < this.apiResult.files.length; i += 1) {
          this.$store.commit('addGDrive', this.apiResult.files[i])
        }
      }).catch(error => {
        this.state = 'error'
        this.apiResult = error
        // console.log(error)
      })
    }
  }
}
</script>
